import React, { useState } from 'react';
import NavBar from '../components/navbar';
import TeamCollaborationExplainer from '../components/TeamCollaborationExplainer';
import AuthModal from '../components/AuthModal';

export default function TeamFeature({ onProfileClick, onBillingClick, onSeatsUpdate }) {
  const [showAuthModal, setShowAuthModal] = useState(false);

  return (
    <div className="App">
      <NavBar onSignInClick={() => setShowAuthModal(true)} onProfileClick={onProfileClick} onBillingClick={onBillingClick} onSeatsUpdate={onSeatsUpdate} />
      <AuthModal showAuthModal={showAuthModal} setShowAuthModal={setShowAuthModal} />
      
      <header className="App-header" style={{
        background: 'linear-gradient(180deg, #eef2f0 0%, #e4ece8 100%)',
        borderBottom: '1px solid #c8d8d2',
        boxShadow: '0 1px 3px rgba(15, 23, 42, 0.07)',
        borderRadius: 0,
        margin: 0,
        padding: '0 20px',
        minHeight: 42,
        flexShrink: 0,
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', position: 'relative' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{
              width: 24, height: 24, borderRadius: 7,
              background: '#d1fae5', color: '#047857',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 14,
            }}>👥</div>
            <h2 style={{
              margin: 0, color: '#1e3a2f',
              fontSize: 14, fontWeight: 700,
              letterSpacing: '-0.01em',
            }}>Teams</h2>
          </div>
        </div>
      </header>

      {/* Team Collaboration Content */}
      <div style={{
        maxWidth: '1100px',
        margin: '20px auto 40px',
        padding: '0 20px'
      }}>
        <TeamCollaborationExplainer 
          showTitle={true}
          compact={false}
          placement="full"
          style={{
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
          }}
        />
      </div>

      {/* Team Collaboration Benefits - Redesigned */}
      <div style={{
        maxWidth: '1100px',
        margin: '10px auto',
        padding: '0 10px'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          borderRadius: '20px',
          padding: '20px 40px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          border: '1px solid rgba(203, 213, 225, 0.5)',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background decoration */}
          <div style={{
            position: 'absolute',
            top: '-50%',
            right: '-20%',
            width: '400px',
            height: '400px',
            background: 'radial-gradient(circle, rgba(59, 130, 246, 0.05) 0%, transparent 70%)',
            borderRadius: '50%'
          }}></div>
          
          <div style={{
            position: 'relative',
            zIndex: 1
          }}>
            <div style={{
              textAlign: 'center',
              marginBottom: '10px'
            }}>
              <h2 style={{
                color: '#1e293b',
                fontSize: '1.7rem',
                fontWeight: '700',
                margin: '0 0 10px 0',
                background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Smart Team Collaboration
              </h2>
              <p style={{
                color: '#64748b',
                fontSize: '1.0rem',
                fontWeight: '500',
                maxWidth: '600px',
                margin: '0 auto',
                lineHeight: '1.6'
              }}>
                Streamline your real estate team's workflow with intelligent automation and seamless communication
              </p>
            </div>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '20px'
            }}>
              <div style={{
                background: 'white',
                borderRadius: '12px',
                padding: '24px 20px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                border: '1px solid #f1f5f9',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '4px',
                  background: 'linear-gradient(90deg, #3b82f6 0%, #1d4ed8 100%)'
                }}></div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '10px'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '20px',
                    marginRight: '12px'
                  }}>
                    🎯
                  </div>
                  <h3 style={{
                    color: '#1e293b',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    margin: '0'
                  }}>
                    Smart Notifications
                  </h3>
                </div>
                <p style={{
                  color: '#64748b',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  margin: '0'
                }}>
                  Intelligent routing prevents notification overload while keeping agents informed of all activity.
                </p>
              </div>
              
              <div style={{
                background: 'white',
                borderRadius: '12px',
                padding: '24px 20px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                border: '1px solid #f1f5f9',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '4px',
                  background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)'
                }}></div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '10px'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '20px',
                    marginRight: '12px'
                  }}>
                    📅
                  </div>
                  <h3 style={{
                    color: '#1e293b',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    margin: '0'
                  }}>
                    Unified Calendar
                  </h3>
                </div>
                <p style={{
                  color: '#64748b',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  margin: '0'
                }}>
                  Centralized calendar with property-specific color coding and automated task synchronization.
                </p>
              </div>
              
              <div style={{
                background: 'white',
                borderRadius: '12px',
                padding: '24px 20px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                border: '1px solid #f1f5f9',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '4px',
                  background: 'linear-gradient(90deg, #8b5cf6 0%, #7c3aed 100%)'
                }}></div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '10px'
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    background: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '20px',
                    marginRight: '12px'
                  }}>
                    ⚡
                  </div>
                  <h3 style={{
                    color: '#1e293b',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    margin: '0'
                  }}>
                    Workflow Efficiency
                  </h3>
                </div>
                <p style={{
                  color: '#64748b',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  margin: '0'
                }}>
                  Streamlined communication hierarchy and role-based access controls boost team productivity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}